import { getMessaging, getToken } from 'firebase/messaging';

export const firebaseConfig = {
  apiKey: 'AIzaSyDYM8fWhLEDk7LXA8t0HxJF7sihxULk4B4',
  authDomain: 'notifications-realtime.firebaseapp.com',
  databaseURL: 'https://notifications-realtime.firebaseio.com',
  projectId: 'notifications-realtime',
  storageBucket: 'notifications-realtime.firebasestorage.app',
  messagingSenderId: '120235207080',
  appId: '1:120235207080:web:4f881618452c14f6c2d59d',
  vapidKey: 'BMr3lKukl4SQpfYgPbskQcoessL0aNgXdXBsSDi-8gcxNYks59kdBBq4AjioKWA_NaWqatpNHv0589lbIxj9i5E',
};

export async function requestPermissions(): Promise<void> {
  await Notification.requestPermission();
}

export async function getPWAToken(vapidKey: string, swRegistration: ServiceWorkerRegistration): Promise<string> {
  const messaging = getMessaging();
  return getToken(messaging, { vapidKey: vapidKey, serviceWorkerRegistration: swRegistration });
}
